module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "part"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#part01",
      "id": "part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "42",
      "src": "OEBPS/images/flow.jpg",
      "width": "85"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "part1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sovereigns in the Making")]), _vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "part1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE FORMATIVE YEARS")]), _vm._v(" (1869-1901)"), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7696c02e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/part01.vue
// module id = 81
// module chunks = 0